/* @jsxImportSource react */

import type { ReactNode } from 'react';
import { cn } from '@packages/shared/src/utils/cn/cn';

interface ProductCardV2BrandProps {
  children: ReactNode;
  id: string;
  className?: string;
}

export const ProductCardV2Brand = ({ children, id, className }: ProductCardV2BrandProps) => (
  <div
    id={`product-${id}-brand`}
    className={cn(
      'product-card-brand text-size-body-sm text-color-text-darktransparent mx-2 mt-2 [grid-area:2/2/span_1/span_1]',
      className,
    )}
  >
    {children}
  </div>
);
